var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification",
    clipPath: "url(#clip0_58716_15316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 59"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_58716_15316",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 33.4286C17 33.1919 17.1919 33 17.4286 33H22.5714C22.8081 33 23 33.1919 23 33.4286C23 34.8487 21.8487 36 20.4286 36H19.5714C18.1513 36 17 34.8487 17 33.4286Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17 33.4286C17 33.1919 17.1919 33 17.4286 33H22.5714C22.8081 33 23 33.1919 23 33.4286C23 34.8487 21.8487 36 20.4286 36H19.5714C18.1513 36 17 34.8487 17 33.4286Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_58716_15316)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 58",
    d: "M9 16C9 9.92487 13.9249 5 20 5C26.0751 5 31 9.92487 31 16V30C31 30.5523 30.5523 31 30 31H10C9.44771 31 9 30.5523 9 30V16Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58716_15316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification4);
export default __webpack_public_path__ + "static/media/Notification (4).16e57405a027a7e651e97441a79d2594.svg";
export { ForwardRef as ReactComponent };